<div class="flex flex-col max-h-screen -m-6 overflow-hidden">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pl-6 pr-4 bg-primary text-on-primary shadow-sm z-10">
        <div class="flex items-center gap-3">
            <mat-icon class="icon-size-6 text-current" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
            <div class="text-lg font-medium leading-none">Business Created</div>
        </div>
        <button mat-icon-button (click)="close()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-1 flex-col p-6 overflow-y-auto">
        <div class="text-base text-secondary mb-6 leading-relaxed">
            The new business account has been successfully created with the following contact number:
        </div>

        <div class="flex flex-col gap-4">
            <div *ngFor="let item of data.businesses" 
                 class="flex items-center p-4 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-primary/50 hover:shadow-md transition-all duration-200">
                
                <!-- Phone Icon -->
                <div class="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mr-4 flex-shrink-0">
                    <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                </div>

                <!-- Contact Details -->
                <div class="flex flex-col flex-1 min-w-0">
                    <span class="text-lg font-semibold text-gray-900">
                        {{ item.business?.contact1 || item.contact1 || 'No Contact' }}
                    </span>
                    <span class="text-sm font-medium text-secondary mt-1" 
                          *ngIf="getBusinessTypeName(item.business?.businessTypeId || item.businessTypeId)">
                        {{ getBusinessTypeName(item.business?.businessTypeId || item.businessTypeId) }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- Actions -->
    <div class="flex flex-0 items-center justify-end h-20 px-6 border-t bg-gray-50/50">
        <button mat-flat-button color="primary" (click)="close()" class="px-8 rounded-full">
            Done
        </button>
    </div>
</div>
